import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoadingIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 96 96",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M48 0C21.4428 0 0 21.5857 0 48C0 74.5572 21.5857 96 48 96C74.5572 96 96 74.4143 96 48C96 21.4448 74.5552 0 48 0ZM48 87.3254C26.3038 87.3254 8.67456 69.6962 8.67456 48C8.67456 26.3038 26.3038 8.67455 48 8.67455C69.6963 8.67455 87.3255 26.3038 87.3255 48C87.3255 69.6962 69.6963 87.3254 48 87.3254Z",
		fill: "url(#paint0_linear_1812_32562)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_1812_32562",
		x1: 89,
		y1: 73.5,
		x2: 14.5,
		y2: 5.5,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#004EFF" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .505208,
				stopColor: "#66C8FF"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "white"
			})
		]
	}) })]
});
export default SvgLoadingIcon;
